import { Component, OnDestroy, OnInit, forwardRef, DoCheck, ChangeDetectorRef, Inject } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { WorkflowComponentNew } from '../../workflow-new.component';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { confirmRemoveFromList } from '@infrastructure/TableEdit/TableEditBase';
import { isUndefined, isNullOrUndefined } from '@infrastructure/objectUtils';

import { BeneficiaryHelperService } from '@infrastructure/Beneficiaries/BeneficiaryHelperService';
import { ModelsService } from '@infrastructure/Models/modelsService';
import { ErrorsOnBeneficiary, MissingField } from '@infrastructure/Beneficiaries/beneficiary-errors.interface';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';



@Component({
  selector: 'beneficiary-list',
  templateUrl: './beneficiary-list.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class BeneficiaryListComponent implements OnInit, OnDestroy {


  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.BeneficiaryVM {
    return this._cardData;
  }
  public set cardData(value: models.BeneficiaryVM) {
    if (value !== null && value !== undefined) {
      value.beneficiaryList.forEach((el, idx) => {
        if (el.beneficiaryID == null) {
          el.beneficiaryID = idx + 1;
        }
      });
    }
    this._cardData = value;
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }

  private _cardData: models.BeneficiaryVM = {} as models.BeneficiaryVM;

  public parentWorkflow: WorkflowComponentNew;
  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberType)
  public subscriberTypes: models.DimensionVM[];
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];
  //@CommonData(DomainCodes.martialStatus)
  //public maritalStatus: models.DimensionVM[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.fiscalCategories)
  public fiscalCategories: models.DimensionVM[];
  @CommonData(DomainCodes.incomeHolding)
  public incomeHoldings: models.DimensionVM[];
  @CommonData(DomainCodes.bankAccountTypes)
  public bankAccountTypes: models.DimensionVM[];


  @CommonData(DomainCodes.studyLevel)
  public educationLevel: models.DimensionVM[];


  public expandNewBeneficiary: boolean = false;
  public expandedRowIndex: number = null;
  public trashIconAppearing = false

  public dropdowns: models.WorkflowDropdownsVM;
  public isServiceOrFunerary: boolean;
  public hasLegalRepresentation: boolean;
  constructor(
    private http: HttpClient, private activeRoute: ActivatedRoute, private modalService: ModalService,
    private readonly changeDetectorRef: ChangeDetectorRef, private BeneficiaryHelperService: BeneficiaryHelperService,
    private modelsService: ModelsService, private legalRepresentationState: LegalRepresentationStateService,
    private beneficiariesStateService: LegalRepresentationStateService) {
  }
 
  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.hasLegalRepresentation = this.parentWorkflow.workflowInstance.StepSender.SenderQualification.isLegalRepresentative;
    this.dropdowns = this.parentWorkflow.workflowDropdowns;
    if (isNullOrUndefined(this.cardData?.beneficiaryList)) {
      this.cardData.beneficiaryList = this.parentWorkflow.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList;
    }

    if (this.parentWorkflow.workflowInstance.StepSender.SenderQualification.isBeneficiary && this.cardData.beneficiaryList.find(b => b.beneficiaryID == 1) == undefined) {

      const senderIdentification = this.parentWorkflow.workflowInstance.StepSender.SenderIdentification
      const senderContacts = this.parentWorkflow.workflowInstance.StepSender.SenderContacts

      let newBeneficiaryFromService: models.BeneficiaryListVM = this.modelsService.getEmptyBeneficiary();
      const beneficiary: models.BeneficiaryListVM = {
        ...newBeneficiaryFromService,
        beneficiaryID: 1,

        beneficiaryName: senderIdentification.name,
        dateOfBirth: senderIdentification.dateOfBirth,

        countryCode: senderContacts.countryCode,
        address: senderContacts.address,
        postalCodeFirst: senderContacts.postalCodeFirst,
        postalCodeLast: senderContacts.postalCodeLast,
        postalDesignation: senderContacts.postalDesignation,
        locality: senderContacts.locality,
        telephone: senderContacts.telephone,
        mobileNumber: senderContacts.mobilePhone,
        email: senderContacts.email
      } as models.BeneficiaryListVM;

      this.cardData.beneficiaryList.push(beneficiary);

    }
    // Check is service or funerary
    this.isServiceOrFunerary = this.parentWorkflow.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary;
  }


  ngOnDestroy(): void {
  }

  public getStateColor(state: string): string {
    return this.legalRepresentationState.getStateColor(state?.toString());
  }

  public getStateText(state: string): string {
    return this.legalRepresentationState.getStateText(state?.toString());
  }

  public getErrorsOnHabilitando(beneficiary: models.BeneficiaryListVM): MissingField[] {
    const result = this.BeneficiaryHelperService.getErrorsOnHabilitando(beneficiary);
    return result.missingFields;
  }

  public isBeneficiaryValid(beneficiary: models.BeneficiaryListVM): boolean {
    const result = this.BeneficiaryHelperService.isBeneficiaryValid(beneficiary);
    return result;
  }

  private onCardDataChanged() {


  }

  onBeneficiaryChanged(newWorkAbroadList: models.BeneficiaryListVM[]) {
    this.cardData.beneficiaryList = newWorkAbroadList;
    this.expandedRowIndex = null;
    this.expandNewBeneficiary = false;
  }

  removeFromList(currentList: any[], tableItem: models.BeneficiaryListVM, event: MouseEvent) {
    const deathDate = (<models.WorkflowTemplateVM_PM>this.parentWorkflow?.workflowInstance).StepDeceased.DeceasedIdentification.deathDate;
    const indexToRemove = currentList.findIndex(b => b.beneficiaryID == tableItem.beneficiaryID)
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result) {
          this.BeneficiaryHelperService.docFaturaOuReciboChange(true, tableItem);
          this.BeneficiaryHelperService.docCerNascimentoReqChange(true, tableItem);
          this.BeneficiaryHelperService.docAtestadoJuntaFreguesiaChange(true, tableItem);
          this.BeneficiaryHelperService.docDeclCompHonraChange(true, tableItem);
          this.BeneficiaryHelperService.docProvaEscolarChange(true, tableItem, deathDate);
          this.BeneficiaryHelperService.docComprovativoSSChange(true, tableItem);
          this.BeneficiaryHelperService.docSentencaChange(true, tableItem);
          this.BeneficiaryHelperService.docDeclaracaoIRSChange(true, tableItem);
          this.BeneficiaryHelperService.docDeclaracaoPensaoAlimentosChange(true, tableItem);
          this.BeneficiaryHelperService.docPrestacoesFamiliaresChange(true, tableItem);
          this.BeneficiaryHelperService.docPSIChange(true, tableItem);
          this.BeneficiaryHelperService.docCertidaoIsensaoIRSChange(true, tableItem);
          this.BeneficiaryHelperService.docComprovativoIBANChange(true, tableItem);

        }

      });
    }
    event.stopPropagation();
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  public removeTrashButton(beneficiaryID) {

    if(this.parentWorkflow.workflowInstance.StepSender.SenderQualification.isBeneficiary && beneficiaryID == 1) {
      this.trashIconAppearing = false
    } else {
      this.trashIconAppearing = true
    }
    return this.trashIconAppearing
  }

  public benefitLabelAppearingFunction(survivalPensionBenefit, reimbursementFuneralBenefit, funeralAllowanceBenefit): String {
    let benefits: String[] = []
    if (!isNullOrUndefined(survivalPensionBenefit) && survivalPensionBenefit) {
      benefits.push("Pensão de sobrevivência")
    }

    if (!isNullOrUndefined(reimbursementFuneralBenefit) && reimbursementFuneralBenefit) {
      benefits.push("Reembolso de despesas de funeral")
    }

    if (!isNullOrUndefined(funeralAllowanceBenefit)  && funeralAllowanceBenefit) {
      benefits.push("Subsídio de morte")
    }

    if (isNullOrUndefined(survivalPensionBenefit) && isNullOrUndefined(reimbursementFuneralBenefit) && isNullOrUndefined(funeralAllowanceBenefit)) {
      return "Por definir"
    }

    return benefits.join(", ")
  }



  public legalRepresentationLabelAppearingFunction(legalRepresentation: String): String {
    if (legalRepresentation?.toString() == 'true') {
      return "Sim"
    } else if (legalRepresentation?.toString() == 'false') {
      return "Não"
    } else {
      return "Por definir"
    }
  }

  public legalRepresentationNameLabelAppearingFunction(legalRepresentation: String, legalRepresentationName: String): String {
    if (legalRepresentation?.toString() == 'true') {
      return legalRepresentationName
    } else {
      return "Não aplicável"
    }
  }

  public isStateRLIndeferido(tableItem: models.BeneficiaryListVM): boolean {
    const result = this.beneficiariesStateService
      .getStateIndeferido(this.hasLegalRepresentation, tableItem.stateRL?.toString());
    return result;
  }
}
